/**
 * legacy (batch) 経路の録音後 / SOAP 生成中 / SOAP 表示統合画面.
 *
 * 本体 JSX は `@/apps/legacy/features/yakureki/screens/PostRecordingScreenContent` に集約済。
 * 本 wrapper は overlay 条件を指定せず content の既定挙動 (patientList.find.status
 * === 'processing') に委ねる (= 従来通りの legacy UX).
 */
import { FC } from 'react'
import { PostRecordingScreenContent } from '@/apps/legacy/features/yakureki/screens/PostRecordingScreenContent'
import type { PostRecordingScreenProps } from '@/apps/legacy/features/yakureki/PostRecordingScreen'

export const PostRecordingConfirmationScreen: FC<PostRecordingScreenProps> = (
  props
) => {
  return <PostRecordingScreenContent {...props} />
}
